import { gql } from '@apollo/client';
import { USER_FIELDS } from '../fragments';

export const UsersSettingsQuery = gql`
  ${USER_FIELDS}
  query PaginatedUsersSettings($query: String, $first: Int, $after: String) {
    allUsersSettings(first: $first, query: $query, after: $after) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ...UserFields
          # ТЗ 0083: рабочая почта — её видят сам сотрудник и Admin, прочим
          # сервер отдаёт null.
          workspaceMailbox {
            email
            displayName
            enabled
            scope
          }
        }
      }
    }
  }
`;

/**
 * ТЗ 0083 — «Мой профиль»: мои данные, рабочая почта и рабочие домены
 * Google Workspace (подсказка адреса при создании сотрудника).
 */
export const MyWorkspaceProfileQuery = gql`
  query MyWorkspaceProfile {
    me {
      id
      pk
      firstName
      lastName
      email
      roles
      workspaceMailbox {
        email
        displayName
        enabled
        scope
      }
    }
    staffMailboxSettings {
      domains
    }
  }
`;

/** ТЗ 0083 — рабочие домены Google Workspace для окна «Новый сотрудник». */
export const StaffMailboxDomainsQuery = gql`
  query StaffMailboxDomains {
    staffMailboxSettings {
      domains
    }
  }
`;
